import { graphql } from "gatsby"
import React from "react"
import HeroBanner from "../components/heroBanner"
import ImageCaption from "../components/imageCaption"
import Layout from "../components/layout"
import MoreArticles from "../components/moreArticles"
import QuestionAnswer from "../components/questionAnswer"
import Quote from "../components/quote"
import Seo from "../components/seo"
import Spacer from "../components/spacer"
import TwoImage from "../components/twoImage"

const Guide = ({ data: { story, journal, nextStories, nextJournals } }) => {
  const post = story || journal
  const isJournal = post?.__typename === "DatoCmsJournal"
  const nextArticles = isJournal ? nextJournals?.nodes : nextStories?.nodes

  return (
    <Layout altFooter={post?.category?.title === "Holiday Journal" ? true : false}>
      <HeroBanner image={post?.image} title={post?.heroTitle} />
      <Spacer />
      <div className='overflow'>
        {post?.articleContent?.map(content => {
          if (content?.id?.includes("Heading")) return <h1 className='text-center h2 story--heading ma p40'>{content?.text}</h1>
          if (content?.id?.includes("Spacer")) return <div className={"spacer " + (content?.hideMobile ? "m-hide" : "")} />
          if (content?.id?.includes("CenteredParagraph"))
            return (
              <div className='p40 m-m0 ml40'>
                <div className={"h5 max-650 ma m0 centered-content white-space block-content"} dangerouslySetInnerHTML={{ __html: content?.content }} />
              </div>
            )
          if (content?.id?.includes("QuestionAnswer")) return <QuestionAnswer image={content?.image} content={content?.qA} caption={content?.imageCaption} overline={isJournal ? content?.overline : undefined} />
          if (content?.id?.includes("Quote")) return <Quote quote={content?.quote} author={content?.author} />
          if (content?.id?.includes("ImageCaption")) return <ImageCaption image={content?.image} position={content?.alignment} caption={content?.caption} overline={isJournal ? content?.overline : undefined} />
          if (content?.id?.includes("TwoImage")) return <TwoImage firstImage={content?.image} firstCaption={content?.caption} secondImage={content?.imageTwo} secondCaption={content?.captionTwo} />
          return null
        })}
      </div>
      <Spacer />
      <MoreArticles articles={nextArticles} isJournal={isJournal} />
      <Spacer />
    </Layout>
  )
}

export default Guide

export const Head = ({ data: { story, journal } }) => {
  const post = story || journal
  return <Seo title={post?.seo?.title || post?.seoTitle || post?.name} description={post?.seo?.description || post?.seoDescription} image={post?.seo?.image?.url} />
}

export const datoQuery = graphql`
  query Guide($slug: String!) {
    story: datoCmsStory(slug: { eq: $slug }) {
      __typename
      name
      caption
      heroTitle
      category {
        title
      }
      image {
        gatsbyImageData
      }
      articleContent {
        ... on DatoCmsHeading {
          id
          text
        }
        ... on DatoCmsCenteredParagraph {
          id
          content
        }
        ... on DatoCmsQuestionAnswer {
          id
          image {
            gatsbyImageData
          }
          imageCaption
          qA {
            answer
          }
        }
        ... on DatoCmsQuote {
          id
          quote
          author
        }
        ... on DatoCmsSpacer {
          id
          hideMobile
        }
        ... on DatoCmsImageCaption {
          id
          alignment
          caption
          image {
            gatsbyImageData
          }
        }
        ... on DatoCmsTwoImage {
          id
          caption
          captionTwo
          image {
            gatsbyImageData
          }
          imageTwo {
            gatsbyImageData
          }
        }
      }
      seo {
        title
        description
        image {
          url
        }
      }
    }
    journal: datoCmsJournal(slug: { eq: $slug }) {
      __typename
      seoTitle
      seoDescription
      name
      caption
      heroTitle
      category {
        title
      }
      image {
        gatsbyImageData
      }
      articleContent {
        ... on DatoCmsHeading {
          id
          text
        }
        ... on DatoCmsCenteredParagraph {
          id
          content
        }
        ... on DatoCmsQuestionAnswer {
          id
          image {
            gatsbyImageData
          }
          overline
          imageCaption
          qA {
            answer
          }
        }
        ... on DatoCmsQuote {
          id
          quote
          author
        }
        ... on DatoCmsSpacer {
          id
          hideMobile
        }
        ... on DatoCmsImageCaption {
          id
          alignment
          overline
          caption
          image {
            gatsbyImageData
          }
        }
        ... on DatoCmsTwoImage {
          id
          caption
          captionTwo
          image {
            gatsbyImageData
          }
          imageTwo {
            gatsbyImageData
          }
        }
      }
      seo {
        title
        description
        image {
          url
        }
      }
    }
    nextStories: allDatoCmsStory(filter: { slug: { ne: $slug } }, limit: 2) {
      nodes {
        name
        caption
        slug
        image {
          gatsbyImageData
        }
      }
    }
    nextJournals: allDatoCmsJournal(filter: { slug: { ne: $slug } }, limit: 2) {
      nodes {
        id
        name
        caption
        slug
        image {
          gatsbyImageData
        }
      }
    }
  }
`
